import {Dialog, DialogPanel, DialogTitle} from '@headlessui/react';

export function NewsletterSignUpPopup({open = false, onClose = () => {}}) {
  const close = () => {
    onClose();
  };
  return (
    <Dialog
      as="div"
      className="relative z-10"
      open={Boolean(open)}
      onClose={close}
    >
      <div className="fixed inset-0 bg-black bg-opacity-25" />

      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <DialogPanel className="modal_newsletter">
            <div>
              <div className="flex justify-between">
                <DialogTitle className="font-semibold text-base leading-6 super-tracking">
                  ENJOY 10% OFF YOUR FIRST ORDER
                </DialogTitle>
                <button className="form-close" onClick={close}>
                  <IconX className="flex align-middle" />
                </button>
              </div>

              <div className="klaviyo-form-YkFEJV forms" />
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}

function IconX() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 4L4 16"
        stroke="black"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M4 4L16 16"
        stroke="black"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/*

<form
  action="https://manage.kmail-lists.com/ajax/subscriptions/subscribe/YkFEJV"
  method="POST"
  id="kmail-subscribe-form-YkFEJV"
  className="k-form k-form-embed forms"
  onSubmit={handleSubmit}
>
  <div className="k-form-fields">
    <div className="k-field k-field-email">
      <input
        type="email"
        name="email"
        placeholder="Email"
        className="minimal-input"
        required
        ref={emailRef}
      />
    </div>
    <div className="k-field k-field-submit">
      <button
        className="primary-submit mt-5"
        type="submit"
        onSubmit={handleSubmit}
      >
        SEND 10% DISCOUNT CODE
      </button>
    </div>
  </div>
</form>;


*/
